import { routerMiddleware, routerReducer } from "react-router-redux";
import { applyMiddleware, combineReducers, compose, createStore, ReducersMapObject, Store, StoreEnhancerStoreCreator } from "redux";
import { History } from "history";
import thunk from "redux-thunk";
import { IAction, IChangeNameAction } from "../actions/actions";
import { getStaticUrl } from "../core/utils/object";
import { IApplicationState } from "../typings";

const defaultState: IApplicationState = {
    ajaxCallsInProgress: 0,
    name: "A",
    counter: 0,
    appLocation: "home",
    routing: {
        location: null,
    },
    modalOpen: 0,
    loginModal: {
        open: false,
        openIn: 0,
    },
    identity: {
        isAuthenticated: false,
        userInfo: undefined,
    },
    admin: {
        users: [],
        expenses: [],
        artworks: [],
    },
    blockchain: {
        successPlugin: false,
        successLogin: false,
    },
    metamaskInfo: {
        address: "",
    },
    etherScan: {
        enabled: false,
        type: 0,
    },
    team: [
        {
            name: "Lorenzo Quinn",
            occupancy: "Funder",
            email: "lorenzoquinn@finearttoken.com",
            image: getStaticUrl() + "images/home/team/lorenzo-quinn.png",
        },
        {
            name: "Nicholas Quinn",
            occupancy: "Coo & Co-Funder",
            email: "lorenzoquinn@finearttoken.com",
            image: getStaticUrl() + "images/home/team/nicholas-quinn.png",
        },
        {
            name: "Ivan Melo",
            occupancy: "CEO & Co-Funder",
            email: "lorenzoquinn@finearttoken.com",
            image: getStaticUrl() + "images/home/team/ivan-melo.png",
        },
        /*{
            name: "Martin Arguello",
            occupancy: "Chief Executive Officer",
            email: "lorenzoquinn@finearttoken.com",
            image: getStaticUrl() + "images/home/team/martin-arguello.png"
        },*/
        {
            name: "Hiram Aragon",
            occupancy: "UX Designer",
            email: "lorenzoquinn@finearttoken.com",
            image: getStaticUrl() + "images/home/team/hiram-aragon.png",
        },
        {
            name: "Norge Vizcay",
            occupancy: "Fullstack Developer",
            email: "norge4522@gmail.com",
            image: getStaticUrl() + "images/home/team/norge.png",
        },
        {
            name: "Javier Cabrera",
            occupancy: "Fullstack Developer",
            email: "xppcoder@gmail.com",
            image: getStaticUrl() + "images/home/team/javier.png",
        },
        /*{
            name: "Sebastian Nielsen",
            occupancy: "Chief Executive Officer",
            email: "lorenzoquinn@finearttoken.com",
            image: getStaticUrl() + "images/home/team/sebastian-nielsen.png"
        },
        /*{
            name: "Javier Cabrera",
            occupancy: "Developer",
            email: "xppcoder@gmail.com",
        }*/
    ],
    featuredArtist: [],
    toasts: {
        messages: {},
    },

    dateVersion: "Date 15/06/2019",
    containerOnScreen: {
        idk: "blue",
    },
};

const incrementReducer = (state = defaultState.counter, action: any) => {
    switch (action.type) {
        default:
            return state;
    }
};

const defaultReducer = (state = defaultState.name, action: IAction) => {
    switch (action.type) {
        case "CHANGE_NAME":
            return (action as IChangeNameAction).name;

        default:
            return state;
    }
};

const locationReducer = (state = defaultState.appLocation, action: any) => {
    switch (action.type) {
        case "CHANGE_LOCATION":
            return action.appLocation;
        default:
            return state;
    }
};

const featuredArtistReducer = (state = defaultState.featuredArtist, action: any) => {
    switch (action.type) {
        case "LOAD_FEATURED":
            return action.featured;
        default:
            return state;
    }
};

const loginModalReducer = (state = defaultState.loginModal, action: any) => {
    switch (action.type) {
        case "OPEN_LOGIN_MODAL":
            return { open: action.value, openIn: action.inPage, preferedRole: action.preferedRole };
        default:
            return state;
    }
};

const teamReducer = (state = defaultState.team, action: any) => {
    return state;
};

const ajaxCallsInProgress = (state = defaultState.ajaxCallsInProgress, action: any) => {
    switch (action.type) {
        case "AJAX_OPERATION_UP":
            return state + 1;
        case "AJAX_OPERATION_DOWN":
            return state - 1;

        default:
            return state;
    }
};

const blockChain = (
    state = defaultState.blockchain,
    action: {
        type: string;
        successLogin: boolean;
        successPlugin: boolean;
    },
) => {
    switch (action.type) {
        case "SUCCESS_PLUGIN":
            return { ...state, successPlugin: action.successPlugin };
        case "SUCCESS_LOGIN":
            return { ...state, successLogin: action.successLogin };

        default:
            return state;
    }
};

const etherReducer = (
    state = defaultState.etherScan,
    action: {
        type: string;
        enabled: boolean;
        etherType: number;
    },
) => {
    switch (action.type) {
        case "ETHER_API":
            return {
                enabled: action.enabled,
                type: action.etherType,
            };
        default:
            return state;
    }
};

const metamaskReducer = (
    state = defaultState.metamaskInfo,
    action: {
        type: string;
    },
) => {
    switch (action.type) {
        case "METAMASK_ADDRESS":
            return { ...state, address: (action as any).address };
        default:
            return state;
    }
};

function buildRootReducer(allReducers: ReducersMapObject) {
    return combineReducers<any>({ ...allReducers, routing: routerReducer });
}

const identityReducer = (state = defaultState.identity, action: any) => {
    switch (action.type) {
        case "CHANGE_AUTH_STATUS":
            return { ...state, isAuthenticated: action.value };
        case "CHANGE_USER_INFO":
            return { ...state, userInfo: { ...action.value } };;
        default:
            return state;
    }
};

const adminReducer = (state = defaultState.admin, action: any) => {
    switch (action.type) {
        case "SET_USERS":
            return { ...state, users: action.value };
        case "SET_EXPENSES":
            return { ...state, expenses: action.value };
        case "SET_ARTWORKS":
            return { ...state, artworks: action.value };
        case "SET_USER_VERIFIED":
            return { ...state, users: state.users.map(u => u.id === action.value ? {...u, is_verified: true} : u) };
        case "SET_USER_REJECTED":
            return { ...state, users: state.users.map(u => u.id === action.value ? {...u, is_verified: false} : u) };
        case "SET_USER_BLOCKED":
            return { ...state, users: state.users.map(u => u.id === action.value ? {...u, blocked: true} : u) };
        case "SET_USER_UNBLOCKED":
            return { ...state, users: state.users.map(u => u.id === action.value ? {...u, blocked: false} : u) };
        case "DELETE_USER":
            return { ...state, users: state.users.filter(u => u.id !== action.value) };
        case "DELETE_ARTWORK":
            return { ...state, artworks: state.artworks.filter(a => a.id !== action.value) };           
        default:
            return state;
    }
};

const containerReducer = (state = defaultState.containerOnScreen, action: any) => {
    switch (action.type) {
        case "CHANGE_CONTAINER":
            return { ...state, ...action.container };

        default:
            return state;
    }
};

const dateReducer = (state = defaultState.dateVersion, action: any) => {
    return state;
};

const modalReducer = (state = defaultState.modalOpen, action: any) => {
    switch (action.type) {
        case "MODAL_UP":
            return 1;
        case "MODAL_DOWN":
            return 0;
        default:
            return state;
    }
};

const toastReducer = (state = defaultState.toasts, action: any) => {
    let messages = state.messages;
    switch (action.type) {
        case "ADD_TOAST_MESSAGE":
            messages[action.id.toString()] = {
                title: action.title,
                description: action.description,
                deadline: action.deadline,
                type: action.messageType,
            };

            return { messages: { ...messages } };
        case "HIDE_TOAST_MESSAGE":
            delete messages[action.v.toString()];

            return { messages: { ...messages } };
        default:
            return state;
    }
};

export default function setupStore(history: History, initialState: any = defaultState) {
    const windowIfDefined = typeof window === "undefined" ? null : (window as any);
    // If devTools is installed, connect to it
    const devToolsExtension = (window as any).__REDUX_DEVTOOLS_EXTENSION__;

    const composeEnhancers =
        typeof window === "object" && (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
            ? (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
                  // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
              })
            : compose;

    const middlewares = [thunk, routerMiddleware(history)];

    const createStoreWithMiddleware = composeEnhancers(applyMiddleware(...middlewares))(createStore);

    var reducers = {
        name: defaultReducer,
        counter: incrementReducer,
        ajaxCallsInProgress,
        appLocation: locationReducer,
        team: teamReducer,
        featuredArtist: featuredArtistReducer,
        loginModal: loginModalReducer,
        identity: identityReducer,
        admin: adminReducer,
        toasts: toastReducer,
        dateVersion: dateReducer,
        modalOpen: modalReducer,
        blockchain: blockChain,
        etherScan: etherReducer,
        metamaskInfo: metamaskReducer,
        containerOnScreen: containerReducer,
    };
    const allReducers = buildRootReducer(reducers);

    const store = createStoreWithMiddleware(allReducers, initialState);

    return store;
}



// WEBPACK FOOTER //
// ./src/reducers/main.reducer.ts